import { style } from 'typestyle'
export const mt52 = style({ marginTop: '52px' })
